import { postData } from '../../../../../api/componentAPIs';
import BaseLocationMapping from '../common/BaseLocationMapping';
import EditForm from './EditForm';
import { sanitizeInput } from '../../../../../utilities/dataUtils';
import DisplayCard from './LocationDisplay';

const LocationMapping = (props) => {
  const populateSubmitDetails = (formData) => {
    const {
      terminalId,
      isNewLocationMapping,
      boundary,
      locationMappingId,
      locationName,
      maxEquipmentSize,
      minEquipmentSize,
      isLiftGateRequired,
      fixedEquipmentSize
    } = formData;
    return {
      terminalId,
      boundary: JSON.stringify(boundary),
      locationMappingId: isNewLocationMapping ? null : locationMappingId,
      locationName: sanitizeInput(locationName),
      maxEquipmentSize,
      minEquipmentSize,
      isLiftGateRequired: Boolean(isLiftGateRequired),
      fixedEquipmentSize
    };
  };

  const saveLocationMapping = (data) => {
    return postData('SaveCustomerLocationMapping', populateSubmitDetails(data));
  };

  return (
    <BaseLocationMapping
      {...props}
      saveLocationMapping={saveLocationMapping}
      locationLabel="Location"
      EditForm={EditForm}
      DisplayCard={DisplayCard}
    />
  );
};

export default LocationMapping;
